import React from "react";
import { injectIntl } from "react-intl";

import Select4 from "../../Generic/Select4";
import { markUpDownContextAction, useMarkUpContext } from "./FeaturesSetupMarkUpContext";
import { MARK_UP_APPLY_TO_TYPES } from "./markUpItemInterface";
import { getRevertedPriceAndCost } from "./markUpFunctions";
import { connect } from "react-redux";
import { AccessRights, PARTS } from "../../../schemas/accessRightsModel";

const FeaturesSetupMarkPopupApplyTo = (props) => {

  const { intl, AR } = props;
  const { markUpDownContextState, markUpDownContextDispatch } = useMarkUpContext();
  const { applyToValue } = markUpDownContextState;

  const isCostModifyEnabled = AR.v(PARTS.PROJECT_SCOPE_COST) || AR.isSiteAdmin(true);

  const selectItems = Object.keys(MARK_UP_APPLY_TO_TYPES)
    .filter(x => isCostModifyEnabled ? true : x !== "cost" && x !== "retailPriceAndCost")
    .map(value => ({
      text: "features.setup.markUpDownPopup.applyTo." + value,
      value: getRevertedPriceAndCost(value)
    }));

  const selected = selectItems.find(item => item.value === applyToValue);

  const selectItemClick = (item) => {
    markUpDownContextDispatch(markUpDownContextAction({
      applyToValue: item.value,
      // activeMarkUpItemIndex: -1, // we should keep selected
    }))
  }

  const label = intl.formatMessage({ id: "features.setup.markUpDownPopup.applyTo" }) + " ";

  return (
    <Select4 selectItemClick={selectItemClick}
      selectItems={selectItems}
      maxItems={selectItems.length}
      label={label}
      className={"select4--blue select4--inverted"}
      selectedItem={selected} />
  )
};

const mapStateToProps = (store) => {
  const AR = AccessRights.get(store);

  return {
    AR,
  };
};

export default injectIntl(
  connect(mapStateToProps)(FeaturesSetupMarkPopupApplyTo)
)
